import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false, name: 'addComma' })
export class AddCommaPipe implements PipeTransform {
  transform(value: []): string {

    return value.join(', ');
  }
}
